import React, {useState, useEffect} from 'react'
import IconCloseNotification from "../../iconComponents/IconCloseNotification";
import {connect, useSelector} from "react-redux";
import {removeNotification, readNotification} from "../../../actions/core";
import {formatDateForNotification, formatDateTimeToZone} from "../../common/Helpers";
import IconTimeSensitive from "../../iconComponents/IconTimeSensitive";
import IconMailClose from "../../iconComponents/IconMailClose";
import IconMailOpen from "../../iconComponents/IconMailOpen";
import { withRouter } from 'react-router-dom';



export function Notification(props) {

const invitation = useSelector((state) => state.contract.invitation);
const [notificationIsHovered, setNotificationIsHovered] = useState(false);
const [closeIsHovered, setCloseIsHovered] = useState(false);

// NOTE: THIS TERNARY FILTERS OLD NOTIFICATION STYLES. UPDATE WHEN ALL NOTIFICATIONS ARE UPDATED.
// ALSO REMOVE ALTERNATIVE action_word "VIEW" FROM BEING RENDERED

const projectName = props.notification.project_name ? props.notification.project_name : "";
const contractName = props.notification.contract_name ? props.notification.contract_name : "";
const invoiceNumber = props.notification.invoice_number ? props.notification.invoice_number : "";
const bullet1 = props.notification.project_name && props.notification.contract_name ? "\u00A0\u00A0\u00A0•\u00A0\u00A0\u00A0" : "";
const bullet2 = props.notification.contract_name && props.notification.invoice_number ? "\u00A0\u00A0\u00A0•\u00A0\u00A0\u00A0" : "";
const lastLine = projectName + bullet1 + contractName + bullet2 + invoiceNumber;


const handleDelete = (e, id) => {
    e.stopPropagation();
    //render(<Modal modalProps={this.deleteModalProps} />);
    props.removeNotification(id);
}

const handleView = (id) => {
    !props.notification.read && props.readNotification(id);
    props.history.push(`/${props.notification.link}`)
}

const dateStyle = props.notification.read ? "light " : "light-black ";
const rowColor = props.notification.read ? "" : "p9";
const rowHoverColor = props.notification.read ? "g9" : "p8c";
const rowStyle = notificationIsHovered ? rowHoverColor : rowColor;
const actionWordColor = props.notification.read ? "heavy g4-text" : "heavy p4-text";
const timerColor = props.notification.read ? "p-fill" : "p4-fill";

    return (
        <>
            <div 
                onMouseEnter={() => setNotificationIsHovered(true)} 
                onMouseLeave={() => setNotificationIsHovered(false)} 
                onClick={() => handleView(props.notification.notification_id)}
                className={`${rowStyle} first ${actionWordColor}`}
                >
                {props.notification.is_time_sensitive &&
                <IconTimeSensitive width="20px" colorClass={timerColor} svgClass="time-sens" />}
                {props.notification.action_word ? props.notification.action_word : "View"}
            </div>
            <div 
                onMouseEnter={() => setNotificationIsHovered(true)} 
                onMouseLeave={() => setNotificationIsHovered(false)} 
                onClick={() => handleView(props.notification.notification_id)}
                className={`${rowStyle} desc`}>
                <div className={props.notification.read ? "" : "light-black"} >{props.notification.description ? props.notification.description : props.notification.notice}</div>
            </div>
            <div 
                onMouseEnter={() => setNotificationIsHovered(true)} 
                onMouseLeave={() => setNotificationIsHovered(false)} 
                onClick={() => handleView(props.notification.notification_id)}
                className={`light ${dateStyle} ${rowStyle}`}>
                {!props.notification.read
                    ?<IconMailClose width="15px" pathClass="p4-fill" svgClass="gap-right-xs" />
                    :<IconMailOpen width="15px" pathClass="g7-fill" svgClass="gap-right-xs" />}
                <span >{formatDateForNotification(props.notification.notification_date)}</span>
            </div>
            <div 
                className={`${rowStyle} close last`}
                onClick={(e) => e.stopPropagation()}>
                <button 
                    onMouseEnter={() => setCloseIsHovered(true)}
                    onMouseLeave={() => setCloseIsHovered(false)} 
                    onClick={(e) => handleDelete(e, props.notification.notification_id)}
                >
                    <IconCloseNotification 
                        height="16px" 
                        pathClass={closeIsHovered ? "g5-fill" : "g7-fill"}
                    />
                </button>
            </div>
                <div 
                    onMouseEnter={() => setNotificationIsHovered(true)} 
                    onMouseLeave={() => setNotificationIsHovered(false)} 

                    onClick={() => handleView(props.notification.notification_id)}
                    className={`desc first bottom ${rowStyle}`}
                    style={{gridColumn: '1 / span 4'}}
                    >
                    <div className={`${rowStyle} content2 light bottom`} >{lastLine}</div>
                </div>

            <hr style={{gridColumn: '1 / span 4'}}></hr>
        </>
    )
}

const mapStateToProps = (state) => ({ })

export default connect(mapStateToProps, {removeNotification, readNotification})(withRouter(Notification));